import { EmptyCard } from '@/domain/mitarbeiter/features/rotationsplan/features/Plaene/components/EmptyCard';
import { RotationsplanCard } from '@/domain/mitarbeiter/features/rotationsplan/features/Plaene/components/RotationsplanCard';
import { useRotationsplaene } from '@/domain/mitarbeiter/features/rotationsplan/hooks/useRotationsplaene/useRotationsplaene';
import { useStandortContext } from '@/features/standortContext/StandortContext';

export function Grid() {
  const { standorte } = useStandortContext();
  const standortIds = standorte.map((standort) => standort.id);
  const { rotationsplaene } = useRotationsplaene(standortIds);

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
      {rotationsplaene.length < 1 ? (
        <EmptyCard />
      ) : (
        rotationsplaene.map((plan) => (
          <RotationsplanCard key={plan.mitarbeiter.id} rotationsplan={plan} />
        ))
      )}
    </div>
  );
}
